import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Home, Link } from 'lucide-react';
const pillars = [{
  icon: Moon,
  emoji: '🌙',
  title: 'Señales Silenciosas',
  body: 'Aprenderás a leer los signos de cansancio antes del bostezo — el lenguaje secreto de tu bebé que nadie te enseñó.'
}, {
  icon: Home,
  emoji: '🏠',
  title: 'La Cueva del Sueño',
  body: 'Configurarás el entorno para que trabaje por ti, no en tu contra. Luz, temperatura, sonido — todo optimizado.'
}, {
  icon: Link,
  emoji: '🔗',
  title: 'Sin Muletas',
  body: 'Eliminarás las dependencias de forma progresiva y respetuosa para que tu hijo aprenda a dormirse solo, sintiéndose seguro.'
}];
export function SolutionSection() {
  return <section className="relative bg-navy-900 py-20 px-4" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-187">
          <p className="font-lato text-gold-400 text-sm font-bold tracking-widest uppercase mb-3" data-id="element-188">
            La Solución
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-cream leading-tight mb-4" data-id="element-189">
            El Método <span className="gold-gradient-text" data-id="element-190">Sueño Profundo</span>
          </h2>
          <p className="font-lato text-cream/70 text-lg max-w-xl mx-auto" data-id="element-191">
            Años de ciencia del sueño y experiencia con miles de familias,
            condensados en una guía práctica y directa.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-14" data-id="element-192">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.15
          }} className="navy-card rounded-2xl p-8 text-center group hover:border-gold-500/50 transition-colors duration-300" data-id="element-193">
                <div className="text-4xl mb-5" data-id="element-194">{pillar.emoji}</div>
                <h3 className="font-playfair text-xl font-bold text-cream mb-3" data-id="element-195">
                  {pillar.title}
                </h3>
                <p className="font-lato text-cream/70 text-sm leading-relaxed" data-id="element-196">
                  {pillar.body}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Product image repeat */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex flex-col md:flex-row items-center gap-10 navy-card rounded-3xl p-8 md:p-12" data-id="element-197">
          <div className="flex-shrink-0 w-48 md:w-56" data-id="element-198">
            <img src="https://cdn.magicpatterns.com/uploads/d5HYHU22Kw6rTjYdAWsyEM/private_openrouter-generated-image-1771628231678.png" alt="Método Sueño Profundo" className="w-full drop-shadow-2xl" data-id="element-199" />
          </div>
          <div data-id="element-200">
            <h3 className="font-playfair text-2xl md:text-3xl font-bold text-cream mb-4" data-id="element-201">
              "El manual de instrucciones que tu bebé no trajo al nacer."
            </h3>
            <p className="font-lato text-cream/70 leading-relaxed" data-id="element-202">
              He condensado años de ciencia del sueño y experiencia con miles de
              familias en una guía práctica, directa y sin rellenos. Sin teorías
              complicadas. Sin métodos crueles. Solo resultados.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}